
import { BarChart2, Building2, ShieldCheck } from "lucide-react";

const WhyChooseUsSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Por que empresas escolhem nossa plataforma</h2>
          <div className="w-20 h-1 bg-hero-blue mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Oferecemos soluções completas que aumentam a eficiência energética e reduzem custos operacionais
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="flex flex-col items-center text-center p-8 rounded-xl shadow-md hover:shadow-lg transition-all">
            <div className="bg-hero-blue/10 p-5 rounded-full mb-6">
              <BarChart2 className="h-10 w-10 text-hero-blue" />
            </div>
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Retorno de Investimento Acelerado</h3>
            <p className="text-gray-600">
              Nossas soluções permitem que empresas recuperem o investimento em um período médio de 24 meses, com economia garantida por 25 anos.
            </p>
          </div>
          
          <div className="flex flex-col items-center text-center p-8 rounded-xl shadow-md hover:shadow-lg transition-all">
            <div className="bg-hero-green/10 p-5 rounded-full mb-6">
              <Building2 className="h-10 w-10 text-hero-green" />
            </div>
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Soluções para Todos os Portes</h3>
            <p className="text-gray-600">
              De pequenas empresas a grandes corporações, oferecemos sistemas dimensionados sob medida para as necessidades energéticas específicas do seu negócio.
            </p>
          </div>
          
          <div className="flex flex-col items-center text-center p-8 rounded-xl shadow-md hover:shadow-lg transition-all">
            <div className="bg-highlight-yellow/10 p-5 rounded-full mb-6">
              <ShieldCheck className="h-10 w-10 text-highlight-yellow" />
            </div>
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Sustentabilidade Corporativa</h3>
            <p className="text-gray-600">
              Reduza a pegada de carbono da sua empresa e fortaleça sua imagem corporativa com energia limpa e renovável certificada.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
